export const holiday = {
  "Voltar": "Volver",
  "Solicitação para o dia ": "Solicitud para el día ",
  "Acessar perfil": "Acceder al perfil",
  "Cancelar": "Cancelar",
  "Tipo da solicitação:": "Tipo de solicitud:",
  "Período:": "Periodo:",
  "Observação:": "Observación:",
  "Anexo:": "Adjunto:",
  "Ver anexo": "Ver adjunto",
  "por:": "por:",
  "em": "en",
  "Avalie a solicitação": "Evaluar la solicitud",
  "Recusar": "Rechazar",
  "Aprovar": "Aprobar",
  "Enviar notificação por e-mail": "Enviar notificación por correo electrónico",
  "Finalizar solicitação": "Finalizar solicitud",
  "Reprovado": "Reprobado",
  "Aprovado/Cadastrado": "Aprobado/Registrado",
  "Aviso": "Aviso",
  "Férias e afastamentos": "Vacaciones y ausencias",
  "Solicitar Férias ou Afastamento": "Solicitar Vacaciones o Ausencia",
  "Minhas férias e afastamentos": "Mis vacaciones y ausencias",
  "Período": "Periodo",
  "Pesquisar": "Buscar",
  "Tipo": "Tipo",
  "Data de início e fim<": "Fecha de inicio y fin<",
  "Qtde de dias": "Cantidad de días",
  "Motivo": "Motivo",
  "Situação": "Situación",
  "Ação": "Acción",
  "Visualizar": "Visualizar",
  "Nenhuma solicitação de férias ou afastamento cadastrada no Ano selecionado.": "No hay ninguna solicitud de vacaciones o ausencia registrada en el Año seleccionado.",
  "Tivemos um problema com a conexão, tente novamente atualizando a página.": "Tuvimos un problema con la conexión, intente nuevamente actualizando la página.",
  "dia": "día",
  "dias": "días",
  "Gerenciar férias e afastamentos": "Gestionar vacaciones y ausencias",
  "Funcionário": "Empleado",
  "Data de início e fim": "Fecha de inicio y fin",
  "Solicitar Férias/Afastamento": "Solicitar Vacaciones/Ausencia",
  "Férias": "Vacaciones",
  "Afastamento": "Ausencia",
  "Tipo de afastamento": "Tipo de ausencia",
  "Selecione": "Seleccione",
  "Campo obrigatório.": "Campo obligatorio.",
  "Início": "Inicio",
  "Término": "Fin",
  "Quantidade de dias": "Cantidad de días",
  "Adicionar anexo": "Agregar adjunto",
  "Motivo do ponto por exceção": "Motivo del punto por excepción",
  "Observação": "Observación",
  "Enviar Solicitação": "Enviar Solicitud",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "No fue posible realizar el envío de la imagen. Motivo: archivo muy grande por favor enviar un archivo menor que 2MB.",
  "Sucesso": "Éxito",
  "Solicitação realizada com sucesso.": "Solicitud realizada con éxito."
};


// WEBPACK FOOTER //
// ./src/resources/es/holiday.js